/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![UndoIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABLUlEQVR4nO2Ru0oEMRSGI66XVhRR0MLeF7CQtIMz5xIxnrOusoUwj+ADWPkYgo3dvoCNDoIWVmIlVmtho5WghTdmZ6bRdXaaLRbmgxQ5Sf4vJzGmpmZ0ANZLJEl+10O3vYqsR8ByhSwvQPqBLE/IegakB87tzlcSIOt3Ooo5894ssJ4i61ex1neQvCHroW23pysLiGQdWR/z2juSnIDTAMCveO8nnWstAssmsnSA5DPdl3a44f3CQEHEzTVkec0O6blzraWyi/X2kzxk3ehtGO7MlAqApJu3fmytbQx+XGOiqDmXhmcZ0ikV5JLrIAimqoQXEMkykD73MlC3SgV9PjKpIgGS/fxp7/4KSJL/BMB6UUXgvR9H0htkvTfGjJlhYK1txHE8MZTwmpoR5QdMk6OVkxoSzQAAAABJRU5ErkJggg==)
 */
export const UndoIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M2 8a1 1 0 0 1 2 0v3.54A10.26 10.26 0 0 1 12.38 7c4.23 0 7.83 2.74 9.53 6.6a1 1 0 1 1-1.82.8c-1.45-3.25-4.4-5.4-7.71-5.4a8.34 8.34 0 0 0-6.96 4H9a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1V8Z"
        className={colorClass}
      />
    </svg>
  );
};
